import { render, staticRenderFns } from "./BaseLoadingAllScreen.vue?vue&type=template&id=546db83e&scoped=true&"
import script from "./BaseLoadingAllScreen.vue?vue&type=script&lang=js&"
export * from "./BaseLoadingAllScreen.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoadingAllScreen.vue?vue&type=style&index=0&id=546db83e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546db83e",
  null
  
)

export default component.exports